(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/circular-progress", [], factory);
	else if(typeof exports === 'object')
		exports["circular-progress"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["circular-progress"] = factory();
})(this, function() {
return 